import { useAvContext } from '@context/AvContextProvider';
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: Component,
});

function Component() {
  const { accountId } = useAvContext();
  return <Navigate to="/$accountId" from="/" params={{ accountId }} ignoreBlocker />;
}
